export enum HTTPStatusCode {
    OK = 200,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    INTERNAL_SERVER_ERROR = 500,
    SERVICE_UNAVAILABLE = 503
}

export enum RequestStatus {
    UNSYNCED = 'UNSYNCED',
    PENDING = 'PENDING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED'
}

export enum SortOrder {
    UNSPECIFIED = -1,
    ASCENDING = 0,
    DESCENDING = 1
}

// TODO generate from Swagger config

export enum AccessModule {
    PERFORMANCE_MONITORING = 1,
    MARKET_ENVIRONMENT_MONITORING = 2,
    LEADING_OF_OPERATIONS = 3,
    INTELLIGENT_AGENDA = 4
}

export enum AccessFunctionality {
    DASHBOARDS_AND_REPORTS = 1,
    FORECASTS = 2,
    POLLS = 4,
    INDICATOR_MANAGEMENT = 5,
    DATA_SOURCES = 6,
    NEWS = 7,
    MARKET_ANALYSES = 8,
    NEWS_SOURCES = 9,
    STAKEHOLDERS = 10,
    AGENDA_AND_ACTIONS = 11,
    STRATEGY_WORK = 12,
    BILLING_ANALYSES_AND_ALERTS = 13
}

export enum AccessFunctionalityAddOn {
    INITIATIVES_MOBILE_AND_CHAT = 1,
    BUDGETING_AND_ROLLING_FORECASTS = 3,
    STAKEHOLDER_FINANCIAL_STATEMENT = 5,
    BRANDING = 6,
    CO_CREATION = 7,
    TEAM_MANAGEMENT = 8,
    EXECUTION_REVIEW = 9,
    AGENDA_HOME = 10,
    MEETINGS = 11
}

export enum AccessType {
    READ = 1,
    WRITE = 2,
    NO_ACCESS = 3
}

export enum SystemLanguage {
    FINNISH = 1,
    ENGLISH = 2,
    SWEDISH = 3
}

export enum PeriodType {
    DAY = 1,
    WEEK = 2,
    MONTH = 3,
    QUARTER = 5,
    YEAR = 4
}

export enum PerformanceIndicatorDimension {
    ACTUAL = 1,
    BUDGET = 2,
    FORECAST = 3,
    GOAL = 4
}


export enum PerformanceIndicatorPointCalculation {
    VALUE = 1,
    YEAR_CUMULATIVE = 2,
    FISCAL_PERIOD_CUMULATIVE = 5,
    ROLLING = 3,
    YEAR_TOTAL = 6,
    CHANGE = 4,
    TOTAL = 7,
    FISCAL_PERIOD_TOTAL = 8,
    CUMULATIVE = 9,
    LAST_TWELVE_MONTHS = 10
}

export enum PerformanceIndicatorComparisonTarget {
    ACTUAL = 1,
    BUDGET = 2,
    FORECAST = 3,
    GOAL = 4,
    PREVIOUS = 5,
    PREVIOUS_YEAR = 6,
    TWO_YEARS_AGO = 7,
    THREE_YEARS_AGO = 8,
    INDICATOR = 9
}

export enum PerformanceIndicatorComparisonCalculation {
    ABSOLUTE = 1,
    RELATIVE = 2,
    VALUE = 3,
    PORTION = 4,
    DIVISION = 5
}

export enum PerformanceIndicatorValueDependencyRule {
    SUM = 1,
    AVERAGE = 2,
    LAST_VALUE = 3
}

export enum CorporateStructureSortMode {
    NAME = 1,
    VALUE_ASC = 2,
    VALUE_DESC = 3
}

export enum TrackingLevel {
    PRODUCT = 1,
    GEO_AREA = 2,
    CUSTOMER = 3,
    TRACKING_LEVEL_1 = 4,
    TRACKING_LEVEL_2 = 5,
    TRACKING_LEVEL_3 = 6,
    TRACKING_LEVEL_4 = 7,
    COMPANY_LEGAL_ENTITY = 8,
    COMPANY_FUNCTION = 9
}

export enum MarketScopeType {
    FINLAND = 1,
    GLOBAL = 2
}

export enum StakeholderNewsWatchFilterLevel {
    LOOSE = 1,
    MEDIUM = 2,
    STRICT = 3
}

export enum ForesightFactor {
    COMPETITION = 1,
    BUSINESS_CYCLE = 2,
    TREND = 3
}

export enum GoalMetricValueType {
    ACHIEVED_ONCE = 1,
    ACHIEVED_EACH_PERIOD = 2,
    DEFINED_BY_USER = 3
}

export enum StrategicProgramRiskLevel {
    ON_TRACK = 1,
    HAS_ISSUES = 2,
    AT_RISK = 3
}

export enum StrategicProgramStatus {
    OPEN = 1,
    CLOSED = 2,
    DRAFT = 3
}

export enum StrategicProgramFinalStatus {
    COMPLETED_SUCCESSFULLY = 1,
    FAILED = 2,
    CANCELLED = 3
}

export enum StrategicProgramUpdateFrequency {
    WEEK = 1,
    BIWEEKLY = 2,
    MONTH = 3,
    QUARTER = 4,
    YEAR = 5,
    NO_MANUAL_UPDATE = 6
}

export enum StrategyTaxonomy {
    STRATEGY = 1,
    SELECTION = 2,
    GOAL = 3,
    CRITICAL_SUCCESS_FACTORS = 4,
    IDEAL_STATE = 5,
    MILESTONE = 6,
    ACTION = 7,
    DASHBOARD_BLOCK = 8
}

export enum PerformanceIndicatorGroup {
    PROFIT_AND_LOSS = 1,
    BALANCE_SHEET = 2,
    SALES_AND_COSTS = 3,
    FIXED_COSTS = 4,
    CUSTOM = 5
}

export enum PerformancePerspectiveGroup {
    ASSETS = 1,
    LIABILITIES_AND_EQUITY = 2,
    PROFIT_AND_LOSS = 3,
    CASHFLOW = 4,
    PROFITABILITY = 5,
    CUSTOMER = 6,
    MARKET = 7,
    GROWTH = 8,
    PROCESS = 9,
    EFFICIENCY = 10,
    PEOPLE = 11,
    GOALS = 12,
    ACTIONS = 13,
    UNKNOWN = 10000
}

export enum PerformancePerspective {
    FINANCIAL = 1,
    CUSTOMER = 2,
    INTERNAL_PROCESSES = 3,
    LEARNING_AND_GROWTH = 4,
    OTHER = 5
}

export enum DashboardBlockType {
    CARTESIAN = 1,
    COMPARISON_COLUMN = 2,
    NEWSFEED = 4,
    PIE = 6,
    SOLID_GAUGE = 7,
    ACTION = 8,
    COMPARISON_BAR = 9,
    NUMBER = 10,
    EXTERNAL = 13,
    MARKET_OVERVIEW = 14,
    POLL = 15,
    TABLE = 16,
    BUBBLE = 17,
    GOOGLE_SHEET = 18,
    CASHFLOW = 19,
    POWER_BI = 20,
    CUSTOM_TABLE = 21,
    SCENARIO_CASHFLOW = 22,
    STRATEGY = 23,
    MILESTONE = 24
}

export enum StrategyPageBlockType {
    STRATEGIC_GOALS = 1,
    STRATEGY_SELECTIONS = 2,
    KPIS = 3,
    STRATEGIC_ACTIONS = 4,
    INITIATIVES = 5,
    DASHBOARD_BLOCK = 6,
    MEMO_BLOCK = 7
}

export enum IntegrationSource {
    NETVISOR = 1,
    GOOGLE_ANALYTICS = 2,
    GOOGLE_SHEETS = 3,
    EXCEL = 4,
    SIE_UPLOAD = 5,
    PIPEDRIVE = 6,
    PROCOUNTOR = 7,
    CRM_SERVICE = 8,
    ACUTE = 9,
    JIRA = 10,
    HILMA_TENDERS = 11,
    VALUEFRAME = 12,
    FIVALDI = 13,
    LEMONSOFT = 14,
    MICROSOFT_TEAMS = 15,
    TOGGL = 16,
    V10 = 17,
    SEVERA = 18,
    NOVA_SDK = 19,
    L7 = 20,
    E_ACCOUNTING = 21
}

export enum IntegrationSourceStatus {
    READY = 1,
    IN_PROGRESS = 2,
    IN_ERROR = 3,
    CONFIGURATION_PENDING = 4
}

export enum DecisionPollType {
    INITIATIVE = 1,
    ACTION = 2,
    MILESTONE = 3,
    SWOT = 4,
    MEETING = 5,
    INSIGHT = 6
}

export enum ExcelGenerationIndicatorDepthRule {
    ALL_LEVELS = 1,
    HIGHEST_ACCOUNT_GROUPS = 2,
    TWO_LEVELS = 3
}

export enum ExcelGenerationValueWriteRule {
    NOTHING = 1,
    PREVIOUS_ACTUAL = 2,
    PREVIOUS_BUDGET = 3,
    PERIOD_ACTUAL = 4,
    PERIOD_ACTUAL_PLUS_BUDGET = 5,
    PERIOD_ACTUAL_PLUS_FORECAST = 6,
    PERIOD_BUDGET = 7,
    PERIOD_FORECAST = 8
}

export enum ERPDimensionSyncType {
    NO_ACTION = 1,
    SYNC_DIMENSION_AND_TARGET = 2
}

export enum IntegrationDataMappingMatchRule {
    EQUALS = 1,
    GREATER_THAN = 2,
    LESSER_THAN = 3,
    SAME_OR_GREATER_THAN = 4,
    SAME_OR_LESSER_THAN = 5,
    CONTAINS = 6,
    STARTS_WITH = 7,
    ENDS_WITH = 8,
    IS_NOT_EMPTY = 9,
    LENGTH_GREATER_THAN = 10
}

export enum IntegrationDataMappingType {
    INVOICING_DATA = 1,
    ACCOUNTING_DATA = 2,
    ERP_SYNC_CUSTOMER = 3
}

export enum IntegrationDataMappingDimension {
    COMPANY_FUNCTION = 1,
    COMPANY_LEGAL_ENTITY = 2,
    CUSTOMER = 3,
    PRODUCT = 4,
    SEGMENT = 5,
    TRACKING_LEVEL_3 = 6,
    TRACKING_LEVEL_1 = 7,
    TRACKING_LEVEL_2 = 8,
    TRACKING_LEVEL_4 = 9,
    GEO_AREA = 10
}

export enum IntegrationDataMappingSource {
    CONSTANT = 1,
    ACCOUNTING_DATA_DIMENSION1 = 2,
    ACCOUNTING_DATA_DIMENSION2 = 3,
    ACCOUNTING_DATA_DIMENSION3 = 4,
    ACCOUNTING_DATA_DESCRIPTION = 5,
    ACCOUNTING_DATA_ACCOUNT_NUMBER = 6,
    ACCOUNTING_DATA_DEBET = 7,
    ACCOUNTING_DATA_KREDIT = 8,
    INVOICING_DATA_TOTAL_NET_SUM = 9,
    INVOICING_DATA_PRODUCT_CODE = 10,
    INVOICING_DATA_PRODUCT_NAME = 11,
    INVOICING_DATA_DIMENSION1 = 12,
    INVOICING_DATA_DIMENSION2 = 13,
    INVOICING_DATA_DIMENSION3 = 14,
    INVOICING_DATA_ACCOUNTING_SUGGESTION = 15,
    INVOICING_DATA_INVOICING_CUSTOMER_EXTERNAL_ID = 16,
    INVOICING_DATA_PRODUCT_SYNC_GROUP_NAME = 17,
    INVOICING_DATA_CUSTOMER_SYNC_GROUP_NAME = 18,
    INVOICING_DATA_SELLER_IDENTIFIER = 19,
    INVOICING_DATA_INVOICING_CUSTOMER_NAME = 20,
    NETVISOR_INTEGRATION_CUSTOMER_SYNC_COUNTRY_CODE_ISO3166 = 21,
    INVOICING_DATA_INVOICE_COMMENT = 22,
    ACCOUNTING_DATA_DIMENSION4 = 23,
    ACCOUNTING_DATA_DIMENSION5 = 24,
    ACCOUNTING_DATA_DIMENSION6 = 25
}

export enum NetvisorSyncDefaultHandleType {
    CREATE_AND_LINK_GROUP = 1,
    MAP_TO_OTHER = 2,
    DO_NOTHING = 3
}

export enum IntegrationFinancialUploadBatchStatus {
    DRAFT = 1,
    PENDING = 2,
    PROCESSED = 3,
    FAILED = 4
}

export enum DecisionStatus {
    WAITING_FOR_ACKNOWLEDGEMENT = 1,
    CLOSED = 2
}

export enum DecisionTrackingType {
    NO_TRACKING = 1,
    TASK_TO_COMPLETE = 2,
    STRATEGIC_ACTION = 3,
    STRATEGIC_BREAKTHROUGH = 4
}

export enum SheetForecastFileStatus {
    PENDING = 1,
    IN_PROGRESS = 2,
    READY = 3
}

export enum ForecastModelDataEntryType {
    APPLICATION = 1,
    GOOGLE_SHEET = 2,
    EXCEL = 3,
    AUTOMATIC = 4,
    DYNAMIC = 5
}

export enum ForecastModelDataEntryStatus {
    PENDING = 1,
    IN_PROGRESS = 2,
    READY = 3
}

export enum MeetingSectionContentType {
    TEXT = 1,
    GRAPH = 2,
    ACTION = 3,
    MILESTONE = 4,
    SCENARIO = 5,
    OBSERVATION = 6,
    INITIATIVE = 7,
    POLL = 8,
    ATTACHMENT = 9,
    GOOGLE_DOCUMENT = 10,
    NEWS = 11,
    MARKET_TREND = 12
}

export enum PerformanceIndicatorPollValueAggregationType {
    SUM = 1,
    AVERAGE = 2
}

export enum PerformanceIndicatorPollValueType {
    NUMERIC = 1,
    SCALE = 2
}

export enum NotificationSendingTimeType {
    BEGINNING = 1,
    MIDDLE = 2,
    END = 3
}

export enum PerformanceIndicatorCollectionType {
    GROUPS = 1,
    ALL = 2
}

export enum PerformanceIndicatorPollStatus {
    DRAFT = 1,
    RUNNING = 2,
    PENDING = 3
}

export enum AccountingDataTransactionType {
    TRANSACTION = 1,
    START_BALANCE = 2,
    VIRTUAL = 3,
    MANUAL = 4
}

export enum VATPeriodType {
    MONTH = 3,
    QUARTER = 5,
    YEAR = 4
}

export enum CompanyLegalEntityType {
    CORPORATE_PARENT = 1,
    COMPANY = 2,
    FULL_CORPORATE_TRANSACTIONS = 3,
    ONLY_CORPORATE_TRANSACTIONS = 4,
    WITHOUT_CORPORATE_TRANSACTIONS = 5,
    WITH_ALL_CORPORATE_TRANSACTIONS = 6
}

export enum PartnerSupportLevel {
    LEAD = 1,
    SUPPORT = 2,
    ADVISOR = 3
}

export enum PartnerClientCompanyType {
    CLIENT = 1,
    DEMO = 2,
    TEMPLATE = 3
}

export enum PartnerClientCompanyEventType {
    ALERT_TRIGGERED = 1,
    ALERT_REVIEWED = 2,
    ALERT_EVALUATED = 3,
    USER_LOGGED_IN = 4
}

export enum UserAgendaContentType {
    NOTIFICATIONS = 1,
    WAITING_COMMENTS = 2,
    RESPONSIBLE_TASKS = 3
}

export enum DashboardStrategicActionViewType {
    CREATED_BY_ME = 1,
    ASSIGNED_TO_ME = 2,
    IN_PARTICIPATED_STRATEGIES = 3,
    ALL_ACTIONS = 4
}

export enum SheetForecastFileType {
    SUMMING = 1,
    DATA_COLLECTION = 2
}

export enum PerformanceManagementAlertType {
    STANDALONE = 1,
    TEMPLATE = 2,
    BATCH = 3
}

export enum PerformanceManagementAlertActivityStatus {
    DRAFT = 1,
    ACTIVE = 2,
    PAUSED = 3
}

export enum PerformanceManagementAlertTriggerType {
    TIME_CHANGED = 1,
    PERIOD_COMPLETED = 2,
    INDICATOR_VALUE_CHANGED = 3,
    BUDGET_OVERUSED = 4,
    FORECAST_DEPLETED = 5,
    BILLING_COMPLETED = 6
}

export enum PerformanceManagementAlertScore {
    VERY_BAD = 1,
    BAD = 2,
    MODERATE = 3,
    GOOD = 4,
    VERY_GOOD = 5
}

export enum PerformanceManagementAlertEmailTitleType {
    PERIOD_AND_REVENUE_CHANGE = 1,
    PERIOD_CHANGE = 2,
    CUSTOM = 3
}

export enum PerformanceManagementAlertDeliveryChannel {
    EMAIL = 1,
    LINK = 2
}

export enum SheetGoogleTemplateCopiedRangeValueType {
    VALUE = 1,
    FORMULA = 2,
    PROTECTED_CELL = 3,
    FORMAT = 4,
    CONFIGURATION = 5
}

export enum SheetConfigurationForecastDownloadFromSheetRule {
    NONE = 1,
    ALL_PERIODS = 2,
    STARTING_FROM_CURRENT_PERIOD = 3,
    STARTING_FROM_NEXT_PERIOD = 4,
    AFTER_LAST_CONFIRMED_FINANCIAL_NUMBERS = 5,
    UNTIL_END_OF_LAST_CONFIRMED_FINANCIAL_NUMBERS = 6
}

export enum SheetConfigurationForecastUploadToSheetRule {
    NONE = 1,
    ALL_PERIODS = 2,
    UNTIL_PREVIOUS_PERIOD = 3,
    UNTIL_CURRENT_PERIOD = 4,
    LAST_CONFIRMED_FINANCIAL_NUMBERS = 5,
    FROM_BEGINNING_OF_LAST_CONFIRMED_FINANCIAL_NUMBERS = 6
}

export enum RelativeDateType {
    NOW = 1,
    LAST_FINANCIAL_PERIOD = 2,
    FISCAL_PERIOD_START = 3,
    FISCAL_PERIOD_END = 4
}

export enum NotificationType {
    NEWS_ENTRY_COMMENT = 1,
    TREND_TOPIC = 2,
    TREND_TOPIC_COMMENT = 3,
    SWOT_TOPIC = 4,
    SWOT_TOPIC_COMMENT = 5,
    BENCHMARK_SESSION_COMMENT = 6,
    STAKEHOLDER = 7,
    STAKEHOLDER_COMMENT = 8,
    NEWS_SOURCE = 9,
    FORECAST_NOTIFICATION = 10,
    DASHBOARD_PAGE = 11,
    DASHBOARD_BLOCK_COMMENT = 12,
    DASHBOARD_BLOCK_MILESTONE = 13,
    STRATEGY_DESCRIPTION = 14,
    STRATEGIC_PROGRAM = 15,
    STRATEGIC_PROGRAM_STATUS_UPDATE = 16,
    DECISION_TOPIC = 17,
    STRATEGIC_GOAL_MILESTONE = 18,
    STRATEGIC_GOAL_MILESTONE_COMMENT = 19,
    DECISION = 20,
    STRATEGIC_GOAL = 21,
    STRATEGY_FREE_NODE = 22,
    CLOSED_STRATEGIC_PROGRAM = 23,
    ALERT = 24,
    POLL_COMPLETED = 25,
    MEETING_ARCHIVED = 26,
    STRATEGIC_PROGRAM_COMMENT = 27,
    WORKSHOP = 28,
    NEWS_ENTRY = 29
}

export enum PersistentNotificationFeedKey {
    NOTIFICATIONS = 'NOTIFICATIONS',
    INSIGHT_FEED = 'INSIGHT_FEED'
}

export enum Advisory360ServiceLevel {
    CORE = 1,
    PREMIUM = 2,
    AGENDA_PREMIUM = 3
}

export enum ProductPackage {
    OLD = 1,
    ADVISORY360 = 2,
    AGENDA360 = 3,
    MONTHLY_MODULES = 4,
    USER_ROLE_BASED_BILLING = 5,
    SMART_STRATEGY = 6,
    LIGHTWEIGHT_MUNICIPALITY = 7, // this
    GOALWISOR = 8
}

export enum BusinessModelCanvasArea {
    KEY_PARTNERS = 1,
    KEY_ACTIVITIES = 2,
    KEY_RESOURCES = 3,
    VALUE_PROPOSITIONS = 4,
    CUSTOMER_RELATIONSHIPS = 5,
    CHANNELS = 6,
    CUSTOMER_SEGMENTS = 7,
    COST_STRUCTURE = 8,
    REVENUE_STREAMS = 9
}

export enum Agenda360ServiceLevel {
    PERFORMANCE_MANAGEMENT = 1,
    INTELLIGENT_AGENDA = 2,
    STRATEGIC_MANAGEMENT = 3,
    MARKET_RADAR = 4
}

export enum ForesightScenarioBaselineCalculation {
    HISTORICAL = 1,
    HISTORICAL_WITH_MARKET_GROWTH = 2,
    CURRENT_SHARE_OF_REVENUE = 3,
    HISTORICAL_SHARE_OF_REVENUE = 4,
    MS_ML_SSA = 5,
    NONE = 6,
    SCENARIO_BUDGET = 7,
    SOURCE_INDICATOR_BUDGET = 8,
    HISTORICAL_SHARE_OF_FISCAL_PERIOD_REVENUE = 9,
    MANUAL_SHARE_OF_REVENUE = 10
}

export enum CompanyCreationChannel {
    DIRECT = 1,
    NETVISOR_STORE = 2,
    INTERNET = 3
}

export enum StrategicGoalMilestoneStatus {
    DRAFT = 1,
    ACTIVE = 2,
    ARCHIVED = 3,
    COMPLETED = 4
}

export enum StrategicGoalMilestoneFinalStatus {
    VERY_LOW = 1,
    LOW = 2,
    AVERAGE = 3,
    HIGH = 4,
    VERY_HIGH = 5
}

export enum StrategicGoalMilestoneAchievability {
    VERY_LOW = 1,
    LOW = 2,
    MEDIUM = 3,
    HIGH = 4,
    VERY_HIGH = 5
}

export enum StrategyDescriptionStatus {
    PLANNING = 1,
    ACTIVE = 3,
    ARCHIVED = 4
}

export enum StrategyPublishingType {
    WITH_FULL_REVIEW = 1,
    WITHOUT_REVIEW = 2
}

export enum StrategyNamingType {
    SYSTEM_DEFAULT = 1,
    OKR = 2,
    WORKSTREAM = 3,
    CUSTOM = 4,
    OBJECTIVE_ACTION = 5
}

export enum StrategyBreakthroughView {
    SUMMARY = 1,
    DIALOGUE = 2,
    DASHBOARD = 3,
    CONNECTIONS = 4
}

export enum WorkflowType {
    RECORD = 1,
    PREVIEW = 2,
    STATUS_UPDATE = 3
}

export enum NewsEntryEntryStatus {
    RAW = 1,
    DELETED = 2,
    APPROVED = 3
}

export enum SystemUserType {
    NORMAL_USER = 1,
    PARTICIPATOR = 2,
    WORKSHOP_PARTICIPATOR = 3
}

export enum PerformanceIndicatorSystemType {
    FINANCIAL = 1,
    FINANCIAL_OVERVIEW = 2,
    INTEGRATION = 3,
    DEFAULT = 4,
    USER = 5,
    INTERNAL = 6
}

export enum MeetingInvitationPeriodType {
    HOUR = 1,
    DAY = 2,
    WEEK = 3
}

export enum MeetingPresentationDataSource {
    MEETINGS = 1,
    TEMPLATES = 2
}

export enum ScenarioView {
    SUMMARY = 'SUMMARY',
    CASHFLOW = 'CASHFLOW'
}

export enum CashflowCapitalItemGroup {
    INVESTMENTS = 1,
    FUNDING = 2
}

export enum CashflowCapitalItem {
    ASSET_INVESTMENTS = 1,
    ASSET_TRANSFER_INCOME = 2,
    APPROVED_LOANS = 3,
    INVESTMENTS_TO_OTHER_INVESTMENTS = 4,
    LOAN_RECEIVABLES_REPAYMENTS = 5,
    INVESTMENTS_TRANSFER_INCOME = 6,
    RECEIVED_INVESTMENT_INTEREST = 7,
    RECEIVED_INVESTMENT_DIVIDENDS = 8,
    PAID_DIRECT_TAXES_INVESTMENTS = 9,
    PAID_EQUITY_INCREASE = 10,
    REPURCHASE_OWN_SHARES = 11,
    SELL_OWN_SHARES = 12,
    SHORT_TERM_LOAN_WITHDRAWALS = 13,
    SHORT_TERM_LOAN_REPAYMENTS = 14,
    LONG_TERM_LOAN_WITHDRAWALS = 15,
    LONG_TERM_LOAN_REPAYMENTS = 16,
    PAID_INTEREST_AND_FINANCIAL_CHARGES = 17,
    PAID_DIVIDENDS_AND_DISTRIBUTIONS = 18,
    PAID_DIRECT_TAXES_FUNDING = 19
}

export enum BusinessReviewStatus {
    DRAFT = 1,
    ACTIVE = 2,
    CLOSED = 3
}

export enum BusinessReviewSessionStatus {
    VERY_WEAK = 1,
    WEAK = 2,
    MODERATE = 3,
    GOOD = 4,
    VERY_GOOD = 5
}

export enum BusinessModelCanvasItemType {
    NOTE = 1,
    CHART = 2,
    ANALYSIS = 3
}

export enum ForesightScenarioElementCashflowCalculationType {
    SALES = 1,
    FIXED_OR_VARIABLE_COSTS = 2,
    OTHER_COSTS = 3
}

export enum ERPAdminCostDivisionType {
    EVENLY = 1,
    BY_ACCOUNTS = 2,
    BY_FIXED_NUMBERS = 3,
    BY_INDICATOR = 4
}

export enum AgendaContentFilter {
    COMPANY = 1,
    VIRTUAL_TEAM = 2,
    USER = 3,
    ME = 4
}

export enum PerformanceIndicatorCalculationRange {
    CURRENT_FISCAL_PERIOD = 1,
    THREE_MONTHS = 2,
    YEAR = 3
}

export enum ERPNetvisorIntegrationLockPeriod {
    FISCAL_PERIOD = 1,
    VAT_PERIOD = 2,
    PURCHASES = 3
}

export enum MeetingStatus {
    PREPARATION = 1,
    FAMILIARIZE = 2,
    RUNNING = 3,
    REVIEW = 4,
    SIGNING = 5,
    ARCHIVED = 6
}

export enum MeetingMinutesContentType {
    TOPIC_DESCRIPTION = 1,
    COMMENTS = 2,
    NOTES = 3,
    DECISIONS = 4,
    TASKS = 5,
    PDF_ATTACHMENTS = 6,
    TOPIC_IMAGES = 7
}

export enum DecisionTopicStatus {
    DRAFT = 1,
    ACTIVE = 2,
    ARCHIVED = 3
}

export enum StrategicProgramAppearance {
    SIMPLE_EMBEDDED = 'SIMPLE_EMBEDDED',
    EMBEDDED = 'EMBEDDED',
    CHART = 'CHART',
    PULSE_CARD = 'PULSE_CARD'
}

export enum LastFinancialPeriodType {
    NOT_AVAILABLE = 1,
    MANUAL = 2,
    FINANCIAL_SYSTEM = 3,
    ROLLING = 4
}

export enum DashboardBlockCustomTableColumnDefaultFilter {
    NONE = 1,
    FIRST = 2,
    LAST = 3,
    SECOND_TO_LAST = 4,
    SECOND = 5
}

export enum SystemUserRole {
    UNAVAILABLE = 1,
    BOARD_MEMBER = 2,
    CEO = 3,
    MANAGEMENT_TEAM_MEMBER = 4,
    STRATEGY_FACILITATOR = 5,
    MANAGER = 6,
    EXPERT = 7
}

export enum UserRoleBillingUserType {
    FACILITATOR = 1,
    MANAGER = 2,
    PARTICIPANT = 3
}

export enum PerformanceIndicatorValueSource {
    FINANCIAL_SYSTEM = 1,
    POLL = 2,
    MANUAL = 3,
    GOOGLE_SHEETS = 4,
    THIRD_PARTY_SYSTEM = 5,
    CALCULATED = 6,
    SUMMED = 7,
    GOOGLE_ANALYTICS = 8,
    NETVISOR_BILLING = 9
}

export enum StrategyExecutionType {
    BREAKTHROUGH = 1,
    OKR = 2
}

export enum StrategyPublishingLevel {
    ONLY_STRATEGY = 1,
    ALL = 2
}

export enum StrategyAllowUserInviteType {
    NOT_ALLOWED = 1,
    APPROVAL = 2,
    ALLOW = 3
}

export enum DialogFlowTemplateMessageType {
    OUTBOUND_TEXT = 1,
    USER_MULTI_OPTION = 2,
    USER_NUMERIC_INPUT = 3,
    USER_TEXT_INPUT = 4,
    MULTI_OPTION_FROM_DATA_SOURCE = 5,
    CROWD_MULTI_OPTION = 6,
    USER_MULTI_SELECT = 8,
    LOGIC_GATE = 9
}

export enum StrategyProcessSubthemeType {
    WORKSHOP = 1,
    MEETING = 2,
    EXTERNAL_LINK = 3,
    FILE = 4,
    PLACEHOLDER = 5
}

export enum ForecastModelRecordDataImportPeriodType {
    ALL_PERIODS = 1,
    BEGINNING_OF_YEAR = 2,
    BEGINNING_OF_FISCAL_PERIOD = 3,
    AFTER_CONFIRMED_PERIOD = 4,
    CUSTOM = 5
}

export enum StrategyExecutionCustomFieldType {
    ENUM = 1,
    TEXT = 2,
    DATE = 3
}

export enum PublicExternalLinkType {
    ROADMAP = 1,
    STRATEGY_MAP = 2,
    DASHBOARD_PAGE = 3,
    ALERT = 4,
    WORKSHOP = 5,
    DIALOG = 6
}

export enum WorkshopQuestionnaireQuestionType {
    MULTIPLE_CHOICE = 1,
    TEXT = 2
}

export enum WorkshopComparisonResultView {
    PERSONAL = 1,
    AVERAGE = 2,
    SCATTER = 3
}

export enum WorkshopWidgetView {
    ACTIVE = 1,
    EDIT = 2,
    DISABLED = 3,
    RESULTS = 4
}

export enum DashboardPageBlockCustomTableGraphSerieType {
    BAR = 1,
    COLUMN = 2,
    LINE = 3
}

export enum StrategyView {
    ROADMAP = 1,
    MAP = 2,
    KANBAN = 3,
    TIMELINE = 4,
    TABLE = 5,
    STRATEGY = 6,
    ORGANIZATION_CHART = 7,
    DASHBOARD = 8,
    INDICATORS = 9,
    BUSINESS_REVIEW = 10,
    BIG_PICTURE = 11
}

export enum WorkshopPhaseContentCreationRule {
    MANUAL = 1,
    PRESET = 2,
    FROM_RESULT_PHASE = 3,
    ACTIVE_STRATEGIES = 4,
    ACTIVE_GOALS = 5,
    ACTIVE_MILESTONES = 6,
    ACTIVE_TEAM_MILESTONES = 7,
    STAKEHOLDER_GROUPS = 8,
    STAKEHOLDERS = 9,
    FROM_CURRENT_WORKSHOP_PHASE = 10,
    AGGREGATED_IDENTIFICATION_PHASES = 11
}

export enum WorkshopCanvasItemType {
    HINT = 1,
    ITEM_GROUP = 2,
    ITEM = 3,
    NOTE_POSITIONER = 4,
    ITEM_POSITIONER = 5
}

export enum Category {
    MARKETS = 1,
    MODELS = 2,
    PROJECTS = 3,
    RESULTS = 4
}

export enum InsightType {
    NORMAL = 1,
    BREAKTHROUGH_STATUS_UPDATE = 2,
    ACTION_STATUS_UPDATE = 3,
    BUSINESS_REVIEW = 4,
    EXECUTION_BUSINESS_REVIEW = 5
}

export enum InsightReactionType {
    LIKE = 1,
    DISLIKE = 2
}

export enum InsightFeedKey {
    INSIGHT_FEED = 'INSIGHT_FEED',
    FILTERED_INSIGHTS = 'FILTERED_INSIGHTS'
}

export enum InsightCardViewType {
    FEED_PREVIEW = 1,
    FEED_FULL = 2,
    ONLY_DESCRIPTION = 3,
    DIALOG = 4,
    FULL = 5,
    BUSINESS_REVIEW_PREVIEW = 6
}

export enum InsightFilterLogicOperatorType {
    AND = 1,
    OR = 2
}

export enum WorkshopTemplateCategory {
    STAKEHOLDER_ANALYSIS = 1,
    GOAL_PLANNING = 2
}

export enum DayOfWeek {
    SUNDAY = 0,
    MONDAY = 1,
    TUESDAY = 2,
    WEDNESDAY = 3,
    THURSDAY = 4,
    FRIDAY = 5,
    SATURDAY = 6
}

export enum PerformanceIndicatorRelativePeriod {
    PREVIOUS = 1,
    CURRENT = 2,
    NEXT = 3,
    NEXT_PLUS_ONE = 4
}

export enum UserNotificationEventSource {
    NEWSENTRY_COMMENT = 1,
    NEWSENTRY_GAIN_CONTRIBUTORS = 2,
    NEWSENTRY_STATUS_CHANGE = 3,
    NEWSENTRY_QUALIFICATION_STATUS_CHANGE = 4,
    NEWSENTRY_SWOT_SELECTION = 5,
    NEWSENTRY_NEW_ENTRY_IN_FEED = 6,
    DASHBOARD_BLOCK_QUESTION = 7,
    DASHBOARD_BLOCK_RESPONSE = 8,
    INDICATOR_POLL_NEW = 9,
    SWOT_SESSION_NEW = 10,
    SWOT_SESSION_NEW_TOPIC = 11,
    SWOT_TOPIC_NEW_COMMENT = 12,
    NEW_SUBACTION = 13,
    STRATEGY_ACTION_CLOSED = 14,
    NEW_STRATEGY_ACTION_COMMENT = 15,
    WEEKLY_MARKET_RECAP = 16,
    NEWSROOM_HIGHLIGHTS = 17,
    WEEKLY_GOAL_PROGRESS_REMINDER = 18,
    MONTHLY_GOAL_STATUS_UPDATE_REMINDER = 19,
    GOAL_ACTIVITY_CREATION_AND_COMMENT = 20,
    NEWS_ENTRY_UPDATE = 21,
    INSIGHT_COMMENT_AND_FEEDBACK = 22,
    BUDGET_AND_FORECASTING_PROCESS = 23,
    REPORTS = 24,
    MEETING_NOTIFICATIONS = 25,
    WORKSHOP_DISCUSSION = 26,
    POLLS = 27,
    INTEGRATION_ERRORS = 28,
    SUMMARIES = 29
}

export enum WorkshopRatingPhaseWeightedLevel {
    DEFAULT = 1,
    ITEM = 2,
    CATEGORY = 3,
    SUBCATEGORY = 4
}

export enum SystemModuleUriType {
    STRATEGY_SETTINGS = 1,
    ORG_CHART = 2,
    ROADMAP = 3,
    STRATEGY_MAP = 4,
    USERS_AND_ACCESS = 5,
    HOME_PAGE = 6
}

export enum WorkshopPrioritizationVotingType {
    HALF = 1,
    ALL = 2,
    CUSTOM = 3
}

export enum GoalMetricValueSource {
    USER_INPUT = 1,
    EXTERNAL_SOURCE = 2,
    OTHER_METRICS = 3
}

export enum DialogScheduleRhytm {
    WEEK = 1,
    BI_WEEK = 2,
    MONTH = 3
}

export enum DialogFlowTemplateMessageConversionRule {
    IGNORE = 1,
    USER_ROLE = 2,
    PHASE = 3,
    OPEN_AI_LIST = 4,
    OPEN_AI_JSON = 5
}

export enum DialogFlowLogicGateValueSource {
    VARIABLE = 1,
    OPTIONS_ITERATED = 2
}

export enum DialogFlowLogicGateMatchRule {
    EQUALS = 1,
    GREATER_THAN = 2,
    LESSER_THAN = 3,
    SAME_OR_GREATER_THAN = 4,
    SAME_OR_LESSER_THAN = 5,
    CONTAINS = 6,
    STARTS_WITH = 7,
    ENDS_WITH = 8,
    IS_NOT_EMPTY = 9,
    LENGTH_GREATER_THAN = 10
}

export enum DialogFlowMultiOptionDataSource {
    TEAMS = 1,
    USER_ACTIVE_MILESTONES = 2,
    USER_RECENTLY_ACTIVE_MILESTONES = 3,
    TEAM_ACTIVE_MILESTONES = 4,
    TEAM_RECENTLY_ACTIVE_MILESTONES = 5,
    STRATEGIC_GOALS = 6,
    ALL_MILESTONES = 7,
    STRATEGY_SELECTIONS = 8,
    CRITICAL_SUCCESS_FACTORS = 9,
    USER_MESSAGE_ANSWERS = 10,
    STRATEGIES = 11,
    BATCH_STRATEGIC_GOALS = 12
}

export enum StrategySelectElement {
    STRATEGY = 1,
    GOAL = 2,
    MILESTONE = 3,
    PROGRAM = 4
}

export enum GroupCollaborationEntityType {
    WORKSHOP = 1,
    MINDMAP = 2,
    DIALOG = 3
}

export enum GroupCollaborationEntityStatus {
    ACTIVE = 1,
    COMPLETED = 2,
    TEMPLATE = 3
}

export enum GroupCollaborationEntityOwner {
    ALL = 1,
    PERSONAL = 2
}

export enum GroupCollaborationTemplateFilter {
    ALL = 1,
    CUSTOM = 2,
    SYSTEM = 3
}

export enum GroupCollaborationWorkshopDuration {
    ALL = 1,
    FIXED = 2,
    CONTINUOUS = 3
}

export enum AnalysisView {
    WORKSHOPS = 1,
    BUSINESS_MODELS = 2
}

export enum InsightFilterPeriod {
    All = 0,
    Today = 1,
    LastWeek = 2,
    LastTwoWeeks = 3,
    LastMonth = 4,
    Custom = 1000
}

export enum PageOrientation {
    PORTRAIT = 1,
    LANDSCAPE = 2
}

export enum DBBoolean {
    NULL = 0,
    TRUE = 1,
    FALSE = 2
}

export enum ExportStrategyTargetEntityType {
    STRATEGY = 1,
    GOAL = 2,
    MILESTONE = 3,
    STRATEGIC_PROGRAM = 4
}

export enum StrategyElementType {
    MILESTONE = 1,
    STRATEGIC_PROGRAM = 2
}

export enum AdministrationUserType {
    ADMINISTRATOR = 1,
    SUPERUSER = 2,
    DEMO_USER = 3,
    GENERIC_POLL = 4,
    BACKGROUND_SHEET = 5,
    PUBLIC_PAGE_USER = 6
}

export enum BusinessReviewViewType {
    STRATEGY = 1,
    GOAL = 2,
    GOAL_GOAL_METRIC = 3,
    TOP_LEVEL_BREAKTHROUGH = 4,
    TOP_LEVEL_BREAKTHROUGH_STATUS_UPDATES = 5,
    TOP_LEVEL_BREAKTHROUGH_METRICS = 6,
    TOP_LEVEL_BREAKTHROUGH_ACTIONS = 7,
    TOP_LEVEL_BREAKTHROUGH_ACTIONS_COMMENTS = 8,
    SECOND_LEVELBREAKTHROUGH = 9,
     SECOND_LEVELBREAKTHROUGH_STATUS_UPDATES = 10,
    SECOND_LEVELBREAKTHROUGH_METRICS = 11,
    SECOND_LEVEL_BREAKTHROUGH_ACTIONS = 12,
    SECOND_LEVEL_BREAKTHROUGH_ACTIONS_COMMENTS = 13
}

export enum BusinessReviewSectionType {
    INSIGHTS = 1,
    ROOT_STRATEGIC_GOAL_MILESTONES = 2,
    STRATEGIC_GOALS = 3,
    STATUS_UPDATES = 4,
    METRICS = 5,
    TEAMS = 6,
    STRATEGIES = 7,
    ACTIVITY = 8,
    SUB_STRATEGIC_GOAL_MILESTONES = 9,
    ROOT_STRATEGIC_PROGRAMS = 10
}

export enum WorkshopBackgroundImage {
    GRADIENT = 1,
    MOUNTAINS = 2,
    HILLS = 3,
    WAVES = 4,
    TEXTURE = 5
}

export enum WorkshopVersionHistoryChangeType {
    ADD = 1,
    EDIT = 2,
    DELETE = 3
}

export enum WorkshopPhaseContentRowLayout {
    SINGLE_COLUMN = 1,
    TWO_COLUMNS = 2,
    TWO_BY_ONE = 3,
    ONE_BY_TWO = 4,
    THREE_COLUMNS = 5
}

export enum WorkshopWidgetType {
    TEXT = 1,
    CHAT = 2,
    EXTERNAL_CONTENT = 3,
    IDENTIFICATION = 4,
    CROSS_POLLINATION = 5,
    TWO_DIMENSIONAL_RATING = 6,
    PRIORITIZATION = 7,
    LIGHT_PRIORITIZATION = 8,
    COMPARISON = 9,
    MINDMAP = 10,
    QUESTIONNAIRE = 11,
    RESULTS = 12
}

export enum WorkshopWidgetStatus {
    INITIAL = 1,
    IN_PROGRESS = 2,
    PAUSED = 3,
    COMPLETED = 4
}

export enum WorkshopResultPresentationType {
    SINGLE = 1,
    COMBINED = 2,
    TWO_BY_TWO_GRID = 3,
    BUSINESS_MODEL_CANVAS = 4
}

export enum WorkshopExternalContentType {
    WEBSITE = 1,
    DOCUMENT = 2,
    IMAGE = 3,
    VIDEO = 4
}

export enum StrategyProgressCalculationMethod {
    MANUAL_STATUS_UPDATE = 1,
    OPEN_ITEMS_AVERAGE_PROGRESS = 2,
    INCOMPLETE_ITEMS_AVERAGE_PROGRESS = 3,
    ITEM_COMPLETION_PERCENTAGE = 4
}

export enum StrategyProgressCalculationSource {
    DIRECT_CHILDREN = 1,
    CONNECTED_ITEMS = 2
}

export enum DialogFlowSessionCreationSource {
    WORKSHOP = 1,
    MICROSOFT_TEAMS = 2,
    WHATSAPP = 3,
    STRATEGY_DESCRIPTION = 4,
    STRATEGIC_GOAL = 5,
    STRATEGIC_GOAL_MILESTONE = 6,
    STRATEGIC_PROGRAM = 7
}

export enum DialogDistributionChannel {
    EMAIL = 1,
    MICROSOFT_TEAMS = 2,
    WHATSAPP = 3,
    PUBLIC_EXTERNAL_LINK = 4
}

export enum StrategyExecutionSecondaryStatusUpdateType {
    NONE = 1,
    NORMAL_STATUS_UPDATE = 2,
    COMMUNITY_AVERAGE = 3,
    COMMUNITY_OPINION = 4
}

export enum WorkshopStrategyImportSource {
    NONE = 1,
    STRATEGY = 2,
    GOAL = 3,
    MILESTONE = 4,
    PROGRAM = 5
}
